import { nowIsoAndUnix } from "@@/shared/date-time/iso-and-unix";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    _PayoutTargetBase} from "./_payout-target-base";
import {
    payoutTargetBaseZodSchema,
} from "./_payout-target-base";
import type {
    PayoutTargetId} from "./payout-target-id";
import {
    payoutTargetIdFactory,
    payoutTargetIdZodSchema,
} from "./payout-target-id";

type PayoutTargetBankAccountType = "bank_account";
const payoutTargetBankAccountTypeZodSchema = z.literal("bank_account");

type PayoutTargetBankAccount = _PayoutTargetBase & {
    _id: PayoutTargetId;
    type: PayoutTargetBankAccountType;
    bankAccountNumber: string;
    customMessage?: string | null;
};

/** Allow string but with only digits, no spaces or characters etc */
const bankAccountNumberZodSchema = z.string().regex(/[0-9]/g);

type Params = Except<
    PayoutTargetBankAccount,
    "_id" | "type" | "_type" | "_createdAt"
>;

const bankAccountPayoutTargetFactory = (
    params: Params,
): PayoutTargetBankAccount => {
    return {
        ...params,
        _id: payoutTargetIdFactory(),
        _type: "PAYOUT_TARGET",
        _createdAt: nowIsoAndUnix(),
        type: "bank_account",
    };
};

const payoutTargetBankAccountZodSchema: z.ZodSchema<PayoutTargetBankAccount> =
    z.intersection(
        payoutTargetBaseZodSchema,
        z.object({
            _id: payoutTargetIdZodSchema,
            type: payoutTargetBankAccountTypeZodSchema,
            bankAccountNumber: bankAccountNumberZodSchema,
            customMessage: z.string().nullable(),
        }),
    );

export {
    bankAccountNumberZodSchema,
    bankAccountPayoutTargetFactory,
    payoutTargetBankAccountTypeZodSchema,
    payoutTargetBankAccountZodSchema,
};
export type { PayoutTargetBankAccount, PayoutTargetBankAccountType };
